"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentsAPIs = exports.tournamentsApi = exports.useLazyQueryHook = exports.useQueryHook = exports.client = exports.auth = void 0;
var authApi_1 = require("./api/authApi");
Object.defineProperty(exports, "auth", { enumerable: true, get: function () { return __importDefault(authApi_1).default; } });
var apolloClient_1 = require("./graphql/apolloClient");
Object.defineProperty(exports, "client", { enumerable: true, get: function () { return __importDefault(apolloClient_1).default; } });
var useQueryHook_1 = require("./graphql/useQueryHook");
Object.defineProperty(exports, "useQueryHook", { enumerable: true, get: function () { return __importDefault(useQueryHook_1).default; } });
var useLazyQuery_1 = require("./graphql/useLazyQuery");
Object.defineProperty(exports, "useLazyQueryHook", { enumerable: true, get: function () { return __importDefault(useLazyQuery_1).default; } });
var joinTournamentApi_1 = require("./api/joinTournamentApi");
Object.defineProperty(exports, "tournamentsApi", { enumerable: true, get: function () { return __importDefault(joinTournamentApi_1).default; } });
__exportStar(require("./graphql/queries"), exports);
var tournamentsApi_1 = require("./api/learningPanel/tournamentsApi");
Object.defineProperty(exports, "TournamentsAPIs", { enumerable: true, get: function () { return __importDefault(tournamentsApi_1).default; } });
__exportStar(require("./interfaces"), exports);
